import script from "./VrpMainButton.vue?vue&type=script&setup=true&lang=js"
export * from "./VrpMainButton.vue?vue&type=script&setup=true&lang=js"

import "./VrpMainButton.vue?vue&type=style&index=0&id=50ae6480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ae6480"]])

export default __exports__